export { default } from './DataService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/services/DataService/index.js